<span
  [class.row]="inline"
  *ngIf="control"
  #container
>
  <label  class="form-label"
          *ngIf="label"
          [for]="formControlName"
          [class.col-form-label]="inline"
          [class.col-form-label-sm]="inline && small"
          [class.col-sm-3]="inline"
  >{{ label }} ({{ 'shared.components.datetime_selector.cet_warning' | translate }}) <ng-container *ngIf="tooltipText">
      <span><i [tooltip]="tooltipText" class="fa fa-info-circle"></i></span>
    </ng-container>
  </label>

  <div [class.col-sm-9]="inline">
  <div class="input-group has-validation" [class.p-calendar-small]="small">

    <span *ngIf="prefix" class="input-group-text">
      {{ prefix }}
    </span>

      <p-date-picker
        [defaultDate]="defaultDate"
        [inputId]="formControlName ?? (name ?? undefined)"
        [name]="formControlName ?? (name ?? undefined)"
        [formControl]="internalControl"
        [showTime]="timeMode === TIME_MODE.SET_TIME"
        [showSeconds]="false"
        [hourFormat]="'24'"
        [firstDayOfWeek]="1"

        #datePicker
        (onSelect)="dateSelected($event)"
        (onInput)="inputChanged($event)"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [appendTo]="'body'"
        [dateFormat]="dateFormat"
        [class.is-invalid]="(control.touched && !control.valid)|| !!control.getError('serverError')"
        [class.is-valid]="(control.touched && control.valid)"
      ></p-date-picker>

    <div class="invalid-feedback" *ngIf="!!control.getError('serverError')">{{ control.getError('serverError') }}</div>
    <ng-container *ngFor="let err of control.errors | keyvalue">
      <ng-container *ngIf="(control.touched && control.invalid)">
        <div *ngIf="errorMessages && errorMessages[err.key] " class="invalid-feedback">
          {{ errorMessages[err.key] }}
        </div>
        <div *ngIf="(!errorMessages || !errorMessages[err.key] ) && err.key !== 'serverError'" class="invalid-feedback">
          {{ 'forms.errors.' + err.key | translate }}
        </div>
      </ng-container>

    </ng-container>
  </div>
  </div>
</span>
